 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1COVER from '@/components/01cover'
 import LOVE_1 from '@/components/love_1'
 import A2TITLEPAGE from '@/components/02titlepage'
 import A3DEDICATION from '@/components/03dedication'
 import A4WAIVER from '@/components/04waiver'
 import A5APPLE from '@/components/05apple'
 import A6BLENDER from '@/components/06blender'
 import A7COP from '@/components/07cop'
 import A8DRIFTER from '@/components/08drifter'
 import A9DRIFTER from '@/components/09drifter'
 import A0EAT from '@/components/10eat'
 import A1EAT from '@/components/11eat'
 import A2EAT from '@/components/12eat'
 import A3FIRE from '@/components/13fire'
 import A4FIRE from '@/components/14fire'
 import A5GRANDMA from '@/components/15grandma'
 import A6HIDEANDSEEK from '@/components/16hideandseek'
 import A7HIDEANDSEEK from '@/components/17hideandseek'
 import A8HIDEANDSEEK from '@/components/18hideandseek'
 import A9IDENTITY from '@/components/19identity'
 import A0JUSTICE from '@/components/20justice'
 import A1KNIFEBALL from '@/components/21knifeball'
 import A2LOOTING from '@/components/22looting'
 import A3MARKER from '@/components/23marker'
 import A4NOZZLE from '@/components/24nozzle'
 import A5OPEN from '@/components/25open'
 import A6PUSH from '@/components/26push'
 import A7QUIT from '@/components/27quit'
 import A9RACCOON from '@/components/29raccoon'
 import A0RACCOON from '@/components/30raccoon'
 import A1SUN from '@/components/31sun'
 import A2TATTOO from '@/components/32tattoo'
 import A3TOMBSTONE from '@/components/33tombstone'
 import A4UNDIES from '@/components/34undies'
 import A5DRIFTER from '@/components/35drifter'
 import A6VEGGIES from '@/components/36veggies'
 import A7WASHER from '@/components/37washer'
 import A8EXPLORE from '@/components/38explore'
 import A9YELL from '@/components/39yell'
 import A0ZZZ from '@/components/40zzz'
 import LOVE_2 from '@/components/love_2'
 import A1DISCLAIMER from '@/components/41disclaimer'
 import A2ACKNOWLEDGEMENTS from '@/components/42acknowledgements'
 import A3ABOUTTHEAUTHORS from '@/components/43abouttheauthors'
 import A4PICKLE from '@/components/44pickle'
 import A5COPYRIGHT from '@/components/45copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01cover",
 			"name" : "01cover",
 			"component" : A1COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/02titlepage",
 			"name" : "02titlepage",
 			"component" : A2TITLEPAGE
 		},
 		{
 			"path" : "/03dedication",
 			"name" : "03dedication",
 			"component" : A3DEDICATION
 		},
 		{
 			"path" : "/04waiver",
 			"name" : "04waiver",
 			"component" : A4WAIVER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js